// extracted by mini-css-extract-plugin
export default {"errorModalFooter":"styles_error-modal-footer__Oa7B3"};